/***
 * Gets a random integer between two values.
 * The maximum is exclusive and the minimum is inclusive.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random
 */
export const getRandomInt = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
};

export const getPercentage = (numerator: string, denominator: string): number =>
  (parseFloat(numerator) / parseFloat(denominator)) * 100;

export const getRoundedPercentage = (
  numerator: string,
  denominator: string,
): string =>
  ((parseFloat(numerator) / parseFloat(denominator)) * 100).toFixed(2);
